import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getFacultySliceContent = createAsyncThunk('/facultys/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getFaculty`, {});
    return response;
})

export const facultySlice = createSlice({
    name: 'facultys',
    initialState: {
        isLoading: false,
        facultys : []
    },
    reducers: {
    },
    extraReducers: {
		[getFacultySliceContent.pending]: state => {
			state.isLoading = true
		},
		[getFacultySliceContent.fulfilled]: (state, action) => {
			state.facultys = action.payload.data
			state.isLoading = false
		},
		[getFacultySliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default facultySlice.reducer